<template lang="html">
  <cw-list-cell
    :title="project.name"
    :subtitle="getSubtitleText()"
    :disclosureDetail="
      `${(project.currentDispatchSets && project.currentDispatchSets.length) ||
        ''}`
    "
    :showDisclosureIndicator="showDisclosureIndicator"
    :showSelectedIndicator="showSelectedIndicator"
    :leftIconProps="iconProps"
    class="has-border-bottom"
    @click="$emit('click')"
  >
  </cw-list-cell>
</template>

<script>
export default {
  name: 'cw-project-cell',
  props: {
    project: {
      type: Object,
      required: true,
    },
    showDisclosureIndicator: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSelectedIndicator: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconProps: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: 'pin',
          scale: 2,
          colorClass: 'has-text-grey-light',
        };
      },
    },
  },
  data() {
    return {
      showLocationInfo: false,
    };
  },
  created() {
    // Check if we should show location information
    // This will be true if we have multiple customer locations
    this.showLocationInfo = this.$root.$data.multipleLocations === true;
  },
  methods: {
    getSubtitleText() {
      let subtitle = this.project.address.street;

      // If we have customer data and multiple locations, show the location
      if (this.showLocationInfo && this.project.customer) {
        // Use serviceArea if available
        if (this.project.customer.serviceArea) {
          subtitle += ` (${this.project.customer.serviceArea})`;
        }
        // Fall back to city if available
        else if (
          this.project.customer.address &&
          this.project.customer.address.city
        ) {
          subtitle += ` (${this.project.customer.address.city})`;
        }
        // Fall back to customer name
        else if (this.project.customer.name) {
          subtitle += ` (${this.project.customer.name})`;
        }
      }

      return subtitle;
    },
  },
};
</script>

<style lang="css"></style>
